const c = {
  name: "PlugPluginPartner",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M2,6.5C2,4,4,2,6.5,2C9,2,11,4,11,6.5V30c0,5.5,4.5,10,10,10c5.5,0,10-4.5,10-10v-2h4v-4.1
			c2.8-0.5,5-2.9,5-5.9V8h-2V3c0-1.7-1.3-3-3-3c-1.7,0-3,1.3-3,3v5h-4V3c0-1.7-1.3-3-3-3c-1.7,0-3,1.3-3,3v5h-2v10
			c0,3,2.2,5.4,5,5.9V28h4v2c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8V6.5C13,2.9,10.1,0,6.5,0C2.9,0,0,2.9,0,6.5V24h2V6.5z M26,22
			c-2.2,0-4-1.8-4-4v-8h16v8c0,2.2-1.8,4-4,4H26z M27,24h6v2h-6V24z M24,8V3c0-0.5,0.5-1,1-1c0.5,0,1,0.5,1,1v5H24z M34,8V3
			c0-0.5,0.5-1,1-1c0.5,0,1,0.5,1,1v5H34z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as PlugPluginPartner
};
